import { _ as _sfc_main } from "./VaMessageList.vue_vue_type_script_lang-8d2d236c.mjs";
import { resolveComponent, openBlock, createElementBlock, normalizeStyle, Fragment, renderList, createBlock, createCommentVNode, createTextVNode, toDisplayString } from "vue";
import { _ as _export_sfc } from "../../../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaMessageList_vue_vue_type_style_index_0_lang = "";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_va_icon = resolveComponent("va-icon");
  return _ctx.messages.length ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: "va-message-list",
    style: normalizeStyle(_ctx.computedStyle)
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.messages, (message, index) => {
      return openBlock(), createElementBlock("div", {
        key: index,
        class: "va-message-list__message"
      }, [
        _ctx.hasError ? (openBlock(), createBlock(_component_va_icon, {
          key: 0,
          class: "va-message-list__icon",
          name: "va-warning",
          size: 16
        })) : createCommentVNode("", true),
        createTextVNode(toDisplayString(message), 1)
      ]);
    }), 128))
  ], 4)) : createCommentVNode("", true);
}
const _VaMessageList = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaMessageList as _
};

import '../../../../../VaMessageList.css';
//# sourceMappingURL=VaMessageList-c519de2d.mjs.map
